import { $Q } from '../utils/query-selector';

export const zoomSwipe = () => {
  const widget = $Q('#gorgias-chat-container');
  let lightbox = new PhotoSwipeLightbox({
    gallery: '#zoom-gallery-mobile',
    children: 'a',
    pswpModule: PhotoSwipe,
    tapAction: 'close',
    padding: { left: 16, right: 16 },
  });
  lightbox.init();
  if (widget) {
    lightbox.on('beforeOpen', () => {
      widget.style.display = 'none';
    });
  
    lightbox.on('close', () => {
      widget.style.display = 'block';
    });
  }



};

export const trigger = () => {
  const btnZoom = $Q('#js-zoom');

  if (!btnZoom) return;

  btnZoom.addEventListener('click', () => {
    const imgActive = $Q(
      '#zoom-gallery-mobile .img-magnifier-container.popup-image.swiper-slide-active'
    );
    if (!imgActive) return;

    imgActive.click();
  });
};
